import { Button } from '@/components/ui/button'
import { Link, useLocation } from 'react-router'
import eyeLogo from '@/assets/Landing/eyelogo.svg'
import { ServicesNavButton } from '@podus/ui'

export default function Header() {
  const location = useLocation()
  const isLandingPage = location.pathname === '/'

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <nav className="px-6 lg:px-16 py-[33px] flex items-center justify-between border-b border-[#ddd] bg-white">
      <div className="flex items-center gap-3">
        <Link to="/" className="flex items-center gap-3">
          <img src={eyeLogo} alt="IRIS Logo" className="h-8 lg:h-10" />
          <h1 className="text-xl lg:text-2xl font-bold text-gray-900">
            IRIS
          </h1>
        </Link>
      </div>
      
      {isLandingPage && (
        <div className="hidden lg:flex items-center">
          <button
            onClick={() => scrollToSection('hero')}
            className="text-[#1c1c1f] hover:text-gray-900 font-bold text-[16px] leading-[24px] px-[26px] py-[9px] transition-colors cursor-pointer"
          >
            Home
          </button>
          <div className="w-[1px] h-[32px] bg-gray-300" />
          <button
            onClick={() => scrollToSection('about')}
            className="text-[#1c1c1f] hover:text-gray-900 font-bold text-[16px] leading-[24px] px-[26px] py-[9px] transition-colors cursor-pointer"
          >
            About
          </button>
          <div className="w-[1px] h-[32px] bg-gray-300" />
          <div className="px-[26px] py-[9px]">
            <ServicesNavButton
              style={{ fontSize: 16, fontWeight: 700, lineHeight: '24px', color: '#1c1c1f' }}
            />
          </div>
          <div className="w-[1px] h-[32px] bg-gray-300" />
          <button
            onClick={() => scrollToSection('how-it-works')}
            className="text-[#1c1c1f] hover:text-gray-900 font-bold text-[16px] leading-[24px] px-[26px] py-[9px] transition-colors cursor-pointer"
          >
            How It Works
          </button>
          <div className="w-[1px] h-[32px] bg-gray-300" />
          <button
            onClick={() => scrollToSection('testimony')}
            className="text-[#1c1c1f] hover:text-gray-900 font-bold text-[16px] leading-[24px] px-[26px] py-[9px] transition-colors cursor-pointer"
          >
            Testimony
          </button>
          <div className="w-[1px] h-[32px] bg-gray-300" />
          <button
            onClick={() => scrollToSection('faqs')}
            className="text-[#1c1c1f] hover:text-gray-900 font-bold text-[16px] leading-[24px] px-[26px] py-[9px] transition-colors cursor-pointer"
          >
            FAQs
          </button>
          <div className="w-[1px] h-[32px] bg-gray-300" />
          <button
            onClick={() => scrollToSection('contact')}
            className="text-[#1c1c1f] hover:text-gray-900 font-bold text-[16px] leading-[24px] px-[26px] py-[9px] transition-colors cursor-pointer"
          >
            Contact Us
          </button>
        </div>
      )}

      <div className="flex items-center gap-[18px]">
        {/* <Button
          variant="ghost"
          className="text-[#151515] hover:text-gray-700 font-bold text-[16px] rounded-[75px] px-[30px] py-[15px]"
          asChild
        >
          <Link to="/signup">Sign Up</Link>
        </Button> */}
        <Button
          className="bg-[#151515] hover:bg-gray-800 text-white font-bold text-[16px] rounded-[75px] px-[30px] py-[15px]"
          asChild
        >
          <Link to="/login">Login</Link>
        </Button>
      </div>
    </nav>
  )
}
